<div style="height: calc(100%); display: flex; flex-direction: column;" data-cy="table-container">
  <app-tdo-search *ngIf="isSearchable === true" style="width: 100%; position: relative; top: 1px; flex-basis: fit-content;"
                  (searchChange)="applySearchFilter($event)" placeholder="Search" data-cy="table-search"></app-tdo-search>
  <div style="height: 100%;" *ngIf="dataSource === null || dataSource === undefined || dataSource.data === undefined || dataSource.data === null || dataSource.data.length === 0" data-cy="table-empty-state">
    <div class="tdo-table-no-data" data-cy="table-no-data-message">{{ this.noDataMessage }}</div>
  </div>
  <div *ngIf="dataSource !== null && dataSource !== undefined && dataSource.data !== undefined && dataSource.data.length > 0" style="flex: 1; min-height: 0; overflow-y: auto; padding-right: 1px;" data-cy="table-content">
    <table *ngIf="dataSource.data !== undefined && dataSource.data !== null" mat-table [dataSource]="dataSource" matSort [matSortActive]="sortActive" [matSortDirection]="sortDirection" data-cy="table-main">
      <ng-container *ngFor="let item of dataSource.data[0] | keyvalue" matColumnDef="{{item.key}}">
        <ng-container *ngIf="item.key !== 'actions'"> {{item.key}}
          <th mat-header-cell *matHeaderCellDef mat-sort-header data-cy="table-header-{{item.key}}"> {{ getLabelByKey(item.key.toString()) }} </th>
          <td mat-cell *matCellDef="let row" data-cy="table-cell-{{item.key}}">
            <ng-container *ngIf="getIsColumnEditable(row, item.key)">
              <app-tdo-input (blur)="onEditComplete($event, row)" style="height: 20px; padding: 0; margin: 0; line-height: 0.5; position: relative; top: 0; border-top: 0;" shouldLabelFloat="false" [(ngModel)]="row.model[item.key]" data-cy="table-cell-input-{{item.key}}"></app-tdo-input>
            </ng-container>
            <ng-container *ngIf="!getIsColumnEditable(row, item.key)">
              {{row[item.key]}}
            </ng-container>
          </td>
        </ng-container>
        <ng-container *ngIf="item.key == 'actions'">
          <th mat-header-cell *matHeaderCellDef data-cy="table-actions-header"></th>
          <td mat-cell *matCellDef="let row" data-cy="table-actions-cell">
            <div [style]="getActionRowStyle(row)" style="display: flex; margin-left: auto; margin-right: 0;" data-cy="table-actions-container">
              <ng-container *ngFor="let action of row.actions">
                <ng-container ngSwitch="{{action}}">
                  <button style="flex: 1; cursor: pointer;" *ngSwitchCase="'edit'" mat-icon-button [matTooltip]="row.getActionTooltip(action)" (click)="onRowActionClick($event, row, action)" data-cy="table-action-edit"><mat-icon [style]="row.getActionStyle(action)">mode_edit</mat-icon></button>
                  <button style="flex: 1; cursor: pointer;" *ngSwitchCase="'delete'" mat-icon-button [matTooltip]="row.getActionTooltip(action)" (click)="onRowActionClick($event, row, action)" data-cy="table-action-delete"><mat-icon [style]="row.getActionStyle(action)">delete</mat-icon></button>
                </ng-container>
              </ng-container>
            </div>
          </td>
        </ng-container>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" data-cy="table-header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          (click)="onRowSelected($event, row)"
          [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}"
          (mouseover)="row.hovered = true" (mouseout)="row.hovered = false"
          data-cy="table-data-row"></tr>
      <tr class="mat-row" *matNoDataRow data-cy="table-no-results-row">
        <td class="mat-cell" colspan="4" data-cy="table-no-results-message">No data matching the filter "{{searchInputValue}}"</td>
      </tr>
    </table>
  </div>
  <div style="flex-basis: fit-content;" data-cy="table-paginator-container">
    <ng-container *ngIf="isUsePaginator === true">
      <ng-container *ngIf="pageSizeOptions !== undefined; else singlePageSize">
        <mat-paginator style="flex-basis: fit-content;" [pageSizeOptions]="pageSizeOptions" data-cy="table-paginator-options"></mat-paginator>
      </ng-container>
      <ng-template #singlePageSize>
        <mat-paginator style="flex-basis: fit-content;" [pageSize]="pageSize" data-cy="table-paginator-single"></mat-paginator>
      </ng-template>
    </ng-container>
  </div>
</div>
